module.exports = __webpack_public_path__ + "static/media/video-case.d2eea56f.svg";